import React from "react";
import DivorceRealCostsBox from "./DivorceRealCostsBox";
import DivorceCostCalculator from "./DivorceCostCalculator";
import { STATUS_DATA_COMPLETED } from "@/src/services/divorce/leadStatus";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type DivorceCostBoxProps = {
  divorce?: AbstractCase;
  isInitialCase?: boolean;
};

const DivorceCostBox = ({ divorce, isInitialCase }: DivorceCostBoxProps) => {
  if (isInitialCase || (divorce && divorce.leadStatus < STATUS_DATA_COMPLETED)) {
    return (
      <ContentBox headline={"Kostenrechner"}>
        <DivorceCostCalculator />
      </ContentBox>
    );
  }

  return <ContentBox headline={"Kostenübersicht"}>{divorce && <DivorceRealCostsBox divorce={divorce} />}</ContentBox>;
};

export default DivorceCostBox;
